//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DataProfilingService from '@/apps/data-platform/services/data_quality/data_profiling_service';
import BaseLoading from '@/components/BaseLoading';
import ModalConfirm from '@/components/ModalConfirm';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent';
import { profilingExecution } from '@/mixins/profiling_execution';
import tasks from '@/js/tasks';
export default {
  name: 'ProfilingTableResult',
  mixins: [profilingExecution],
  components: {
    BaseLoading: BaseLoading,
    ModalConfirm: ModalConfirm,
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  props: {
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    tableReference: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    documentId: {
      type: String,
      required: false,
      default: function _default() {
        return null;
      }
    },
    domainTable: {
      type: String,
      required: false,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      MODAL_CONFIRM_EDIT: 'MODAL_CONFIRM_EDIT',
      commentary: '',
      filter: '',
      isBusy: false,
      filterOn: [],
      referenceRule: null
    };
  },
  computed: {
    fields: function fields() {
      return [{
        text: this.traductor('tablas.columns'),
        value: 'column_name',
        sortable: true
      }, {
        text: this.traductor('tablas.data_type'),
        value: 'data_type',
        sortable: true
      }, {
        text: this.traductor('tablas.no_null'),
        value: 'pct_null',
        sortable: true
      }, {
        text: this.traductor('tablas.q_no_null'),
        value: 'q_no_null',
        sortable: true
      }, {
        text: this.traductor('tablas.q_null'),
        value: 'q_null',
        sortable: true
      }, {
        text: this.traductor('tablas.empty_space'),
        value: 'pct_empty_space',
        sortable: true
      }, {
        text: this.traductor('tablas.q_empty_space'),
        value: 'q_empty_space',
        sortable: true
      }, {
        text: this.traductor('tablas.unique_value'),
        value: 'pct_unique_value',
        sortable: true
      }, {
        text: this.traductor('tablas.numeric'),
        value: 'pct_numeric',
        sortable: true
      }, {
        text: this.traductor('tablas.q_no_numeric'),
        value: 'q_no_numeric',
        sortable: true
      }, {
        text: this.traductor('tablas.q_freq_value'),
        value: 'pct_freq_value',
        sortable: true
      }, {
        text: this.traductor('tablas.most_freq_value'),
        value: 'q_freq_value',
        sortable: true
      }, {
        text: this.traductor('tablas.max_length'),
        value: 'max_length',
        sortable: true
      }, {
        text: this.traductor('tablas.values'),
        value: 'max_length_value',
        sortable: true
      }];
    },
    texts: function texts() {
      return {
        version: this.traductor('frases.profiling_version'),
        execution_date: this.traductor('tablas.execution_date'),
        rows_quantity: this.traductor('frases.rows_quantity'),
        table_key: this.traductor('frases.table_key'),
        unique_key: this.traductor('frases.unique_key'),
        reference_score: this.traductor('frases.reference_score'),
        comments: this.traductor('frases.comments'),
        enter: this.traductor('frases.enter'),
        filter: this.traductor('frases.filter'),
        search: this.traductor('frases.type_search')
      };
    },
    scoreColor: function scoreColor() {
      if (this.referenceRule != null && Object.keys(this.referenceRule).length > 0) {
        var score = this.referenceRule['last_execution'].resultsTable.score;
        var profilingRule = this.referenceRule.profilingRule;
        var lower = profilingRule.lowerThreshold;
        var upper = profilingRule.upperThreshold;
        return {
          'text-success': score >= upper,
          'text-warning': lower <= score && score < upper,
          'text-danger': score < lower
        };
      } else {
        return {};
      }
    }
  },
  created: function created() {
    this.getReferenceRule();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    openModal: function openModal() {
      this.$refs[this.MODAL_CONFIRM_EDIT].onOpen();
    },
    getReferenceRule: function getReferenceRule() {
      var _this = this;
      var tableReference = this.tableReference['project'] ? {
        projectId: this.tableReference['project'],
        datasetId: this.tableReference['bigquery_dataset'],
        tableId: this.tableReference['bigquery_table']
      } : this.tableReference;
      var params = {
        domainTable: this.domainTable,
        tableReference: tableReference
      };
      DataProfilingService.getReferenceRule(params).then(function (response) {
        console.log('ref: ', response.data);
        _this.referenceRule = response.data;
      });
    },
    onSubmit: function onSubmit(event) {
      var _this2 = this;
      if (!event) {
        this.$refs[this.MODAL_CONFIRM_EDIT].onClose();
      } else {
        this.isBusy = true;
        var execution = this.profiling_execution;
        var params = {
          domain_table: this.domainTable,
          parent_id: this.documentId,
          execution: execution
        };
        DataProfilingService.updateExecution(params).then(function (response) {
          if (response.code === 200) {
            tasks.toast.success('Comments updated!');
            // this.$toast.success("Comments updated!")
          }
        }).then(function () {
          _this2.isBusy = false;
          _this2.$refs[_this2.MODAL_CONFIRM_EDIT].onClose();
        });
      }
    },
    onCancel: function onCancel() {
      this.$emit('closeModal');
    }
  }
};